// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"129fd037","893":"20566230","976":"f83b7538"}[chunkId] + ".chunk.js";
};